export default "__VITE_PUBLIC_ASSET__d4ef062f__"